<template lang="html">
  <div class="">
    <div class="container">
      <el-result icon="success"
        :title="title"
        :subTitle="subTitle"
      >
        <template slot="extra" v-if="action">
          <el-button
            type="primary"
            size="medium"
            @click="routeTo"
          >
            {{action.title}}
          </el-button>
        </template>
      </el-result>
    </div>
  </div>
</template>

<script>
  import { Result } from 'element-ui'
  import Vue from 'vue'
  import router from '../router'
  Vue.use(Result)

  export default {
    components: {
    },
    props: {
    },
    data() {
      return {
        title: '',
        subTitle: '',
        action: {}
      };
    },
    computed: {
      
    },
    methods: {
      routeTo: function () {
        router.replace({
          name: this.action.routeName
        })
      }
    },
    mounted () {
      window.console.log("组件启动")
      window.console.log(`this.$route.params.action: ${this.$route.action}`)
      this.title = this.$route.params.title
      this.subTitle = this.$route.params.subTitle
      if (this.$route.params.action) {
        this.action = this.$route.params.action
      }
    },
    destroyed () {
      window.console.log("组件卸载")
    }
  }
</script>

<style lang="css" scoped>
  
</style>
